import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { getAllOffersPosition } from "../../../../../services/offers/get-all-offers-position";
import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
import { GoBackButton } from "../../../../../components/GoBackButton";
import { useEffect, useState } from "react";
import { LoadingBackDrop } from "../../../../../components/loader";

import OfferingPositionEditForm from "./offering-edit-position-form";
import { OffersPositionItem } from "../../../../../services/offers/get-all-offers-position/types";

const OfferingPositionEdit = () => {
  const { id } = useParams();
  const [offerPosition, setOfferPosition] = useState<OffersPositionItem>();
  const body = {
    paginacja: null,
    filtr: {
      id_pozycji_oferty: id,
    },
  };
  const GetAllOffersPosition = useQuery(
    ["AllOffersPosition"],
    () => getAllOffersPosition(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        setOfferPosition(data.data.payload.pozycje_oferty[0]);
      },
    }
  );

  if (
    GetAllOffersPosition.isLoading ||
    GetAllOffersPosition.isRefetching ||
    offerPosition === undefined
  ) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
      <ButtonWrapper>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
      </ButtonWrapper>
      <OfferingPositionEditContainer>
        <OfferingPositionEditForm offerPosition={offerPosition} />
      </OfferingPositionEditContainer>
    </>
  );
};

export default OfferingPositionEdit;

const OfferingPositionEditContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  padding-top: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: -50px;
  }
`;
const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  // display: flex;
  // justify-content: flex-start;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
  }
`;
